import React, { Component } from 'react'

import { FillerDiv } from '../StyledComponents/Fillers'
import {
    MainButtonWrapper,
    FABButtonIcon,
    FABButtonItemWrapper,
    FABButtonLink,
    FABButtonAction
} from '../StyledComponents/Global/FABButton'

import { CLASSIFIER } from '../../constants/routes'

class FABButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
            open: false,
        }

        this.toggle = this.toggle.bind(this)
        this.openSearch = this.openSearch.bind(this)
        this.openFilter = this.openFilter.bind(this)
    }

    toggle() {
        this.setState({ open: !this.state.open })
    }

    openSearch() {
        this.props.onSearchClicked()
        this.toggle()
    }

    openFilter() {
        this.props.onFilterClicked()
        this.toggle()
    }

    renderItem(type, index) {
        let icon = null
        switch (type) {
            case 'search':
                icon = (
                    <FABButtonAction onClick={this.openSearch}>
                        <FABButtonIcon name="search" size="2x" />
                    </FABButtonAction>
                )
                break
            case 'visual-recognititon':
                icon = (
                    <FABButtonLink to={CLASSIFIER}>
                        <FABButtonIcon name="camera" size="2x" />
                    </FABButtonLink>
                )
                break
            case 'filter':
                icon = (
                    <FABButtonAction onClick={this.openFilter}>
                        <FABButtonIcon name="filter" size="2x" />
                    </FABButtonAction>
                )
                break
            default:
        }

        return (
            <FABButtonItemWrapper index={index} key={type}>
                {icon}
            </FABButtonItemWrapper>
        )
    }

    render() {
        const { items } = this.props
        const { open } = this.state

        const buttons = open
            ? items.map((item, index) => this.renderItem(item, index))
            : null

        return (
            <FillerDiv>
                {buttons}
                <MainButtonWrapper open={open} onClick={this.toggle}>
                    <FABButtonIcon name={open ? 'times' : 'plus'} size="2x" />
                </MainButtonWrapper>
            </FillerDiv>
        )
    }
}

export default FABButton



// WEBPACK FOOTER //
// ./src/components/Global/FABButton.js